/**
 *  Tacs
 *
 *  Created by Legman on 06/06/2017.
 *
 */

import Bomb from "./Bomb";
import Common from "../Common";

/**
 * @class
 * @extends Bomb
 */
export default class Tacs extends Bomb {
    /**
     * @param {RaceCar} owner
     */
    constructor(owner) {
        super(owner);

        this._view.texture = Common.assets.getTexture("game_powerup_nails");
    }

    arm() {
        this._view.texture = Common.assets.getTexture("powerup_patch_tacks");
        this.offset.y += 80;
        this.scale = new PIXI.Point(2, 2);

        super.arm();
    }

    _createEmitter() {
        const assets = Common.assets;
        const config = assets.getJSON("particle_emitter_candy_blast_00");

        const holder = new PIXI.Container();
        this._view.addChild(holder);

        this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particles_powerup_nail_00")], config);
    }
}